module.exports = __webpack_public_path__ + "media/images/menu/triangulum-4559aaa7b912b5cde5e73cdb6b5169f4.jpg";